import iconErr from '@/components/icon/icon_err';
import iconWin from '@/components/icon/icon_win.vue';
const typeList = {
  error: iconErr,
  success: iconWin
};
export function MessageBox(mag, type = 'success', params = {}) {
  let dom = document.body;
  if (params.appendTo) {
    dom = document.getElementById(params.appendTo);
  }
  ElMessage({
    message: mag,
    grouping: true,
    appendTo: dom,
    dangerouslyUseHTMLString: params.dangerouslyUseHTMLString || false,
    offset: params.offset || 16,
    customClass: 'messagebox',
    icon: typeList[type],
    duration: 2000
  });
}
export function MessageBoxImport(mag, type = 'success', params = {}) {
  let dom = document.body;
  if (params.appendTo) {
    dom = document.getElementById(params.appendTo);
  }
  ElMessage({
    message: mag,
    grouping: true,
    appendTo: dom,
    dangerouslyUseHTMLString: params.dangerouslyUseHTMLString || false,
    offset: params.offset || 16,
    customClass: 'messagebox',
    icon: typeList[type],
    duration: 8000
  });
}